import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  Pagination,
  Button,
} from "@mui/material";
import view from "../../Admin/assets/icons/view.svg";
import add from "../../Admin/assets/icons/add.svg";
import cart_icon from '../../User/assets/icons/cart.svg';
import delete_icon from '../../User/assets/icons/delete.svg';
import Image from '../../Utils/getImage';
import payment_icon from '../../Admin/assets/icons/raise_payment.svg';
import deadline_icon from '../../Admin/assets/icons/order_deadline.svg';
import payment_status from '../../Admin/assets/icons/payment-status.png'


const CommonTable = ({
  setCurrentPages, currentPage, totalCount, rowsperpage, columns, rows, menu,
  banner, paymentstatus, deadline, bannerdelete, setOpenConsultationDialog,
  cart, orderinfo, handleOrderClick, handleEditClick, handleViewClick, handleDeleteClick, handleStatusClick, handleAssigntailorClick,
  totalpages, handleCartClick,
  handlepaymentstatus, handleAdddocumnentClick, handleAddImageClick, handleEmpolyeestatusClick,
  handleSuborderAssignClick, handleSubAdddocumnentClick, handleraiseClick, handleaccept }) => {
  const role = localStorage.getItem("role");
  const id = localStorage.getItem("id");
  const handleRowClick = () => {
    setOpenConsultationDialog(true);
  };



  const getInitials = (name = "") => {
    const words = name.trim().split(" ");
    if (words.length === 1) return words[0].charAt(0).toUpperCase();
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  return (
    <div className="employee-table">
      <TableContainer component={Paper} sx={{
        maxWidth: '100%',
        overflowX: 'auto'
      }}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {columns &&
                columns.map((col, index) => (
                  <TableCell key={index}>
                    <div className="employee-name">
                      {col.label}
                    </div>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows && rows.length > 0 ? (
              rows.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((col, colIndex) => (
                    <TableCell
                      key={colIndex}
                      align="left"
                      onClick={row[col.onclick]}
                      sx={{
                        width: col.width,
                      }}
                    >
                      {col.field === "sub-sub-category" ? (
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() => handleRowClick(row[col.field])}
                        >
                          {row[col.field]}
                        </span>
                      ) : col.field === "action" ? ( //action
                        <div className="tickects-lasttablecell">
                          {banner === true ? <span className="view-btn">
                            <img onClick={() => handleViewClick(row)} src={view} alt="view" />
                          </span> : null}
                          {bannerdelete === true ? <span className="view-btn">
                            <img onClick={() => handleDeleteClick(row)} src={delete_icon} alt="delete_icon" />
                          </span> : null}
                          {cart === true ? <span className="view-btn">
                            <img onClick={() => handleCartClick(row)} src={cart_icon} alt="cart_icon" />
                          </span> : null}
                          {orderinfo === true ? <span className="view-btn">
                            <img onClick={() => handleOrderClick(row)} src={view} alt="view" />
                          </span> : null}
                          {menu === true && (
                            <span className="edit-btn">
                              {row?.consultantData ? (
                                row.consultantData.status === "Cancelled" || row.consultantData.status === "Canceled" || row.consultantData.status === "Completed" ? null : (
                                  row.consultantData.assigned_to === id || role === "Admin" || role === "SeniorDesigner" || role === "JuniorDesigner" ? (
                                    <img onClick={() => handleEditClick(row)} src={add} alt="edit" />
                                  ) : row.consultantData.assigned_to ? null : (
                                    <Button className="common_button" onClick={() => handleaccept(row)}>
                                      Accept
                                    </Button>
                                  )
                                )
                              ) : (
                                <img onClick={() => handleEditClick(row)} src={add} alt="edit" />
                              )}

                            </span>
                          )}
                          {/* {!["Delivered", "Canceled"].includes(row.Orderstatus) && payment ? <span style={{ cursor: "pointer" }}>
                            <img onClick={() => handlePaymentClick(row)} src={payment_icon} alt="payment_icon" width={20} height={20} />
                          </span>
                            : null} */}
                          {!["Delivered", "Canceled", "Cancelled"].includes(row.Orderstatus) && deadline ? <span style={{ cursor: "pointer" }}>
                            <img onClick={() => handleraiseClick(row)} src={deadline_icon} alt="deadline_icon" width={20} height={20} />
                          </span>
                            : null}
                          {paymentstatus === true ? <span style={{ cursor: "pointer" }}>
                            <img onClick={() => handlepaymentstatus(row)} src={payment_status} alt="payment_status" style={{ width: "25px", height: "25px", objectFit: "fill" }} />
                          </span>
                            : null}
                        </div>
                      ) : col.field == "CommonStatus" ? (
                        <span
                          style={{
                            backgroundColor: (() => {
                              switch (row[col.field]) {
                                case "Unassigned":
                                  return "#FCEBEA";
                                case "Assigned":
                                  return "#F1FDFF";
                                case "Delivered":
                                  return "#E1FCEF";
                                case "In Payment":
                                  return "#EBF0FA"
                                case "In Progress":
                                  return "#FCF2E6"
                                case "In Transit":
                                  return "#EDEDFC"
                                case "Completed":
                                  return "#E1FCEF"; // Shared Green for these statuses
                                case "Canceled":
                                case "Cancelled":
                                  return "#FFEDEF";
                                case "Active":
                                  return "#E1FCEF";
                                case "Inactive":
                                  return "#FFEDEF";
                                default:
                                  return "#E9EDF5"; // Default Gray for unknown status
                              }
                            })(),
                            color: (() => {
                              switch (row[col.field]) {
                                case "Unassigned":
                                  return "#FF928A"; // Dark text for Yellow
                                case "Assigned":
                                  return "#3CC3DF";
                                case "Delivered":
                                  return "#E1FCEF";
                                case "In Payment":
                                  return "#2264E5";
                                case "In Progress":
                                  return "#AA5B00";
                                case "In Transit":
                                  return "#5E5ADB"; // White text for other statuses
                                case "Completed":
                                  return "#14804A"; // White text for other statuses
                                case "Canceled":
                                case "Cancelled":
                                  return "#D1293D"; // White text for other statuses
                                case "Active":
                                  return "#14804A";
                                case "Inactive":
                                  return "#D1293D";
                                default:
                                  return "#fff"; // Light gray text for default
                              }
                            })(),
                            padding: "5px 10px",
                            borderRadius: "5px",
                            textAlign: "center",
                            cursor: "pointer",
                          }}
                        >
                          {row[col.field]}
                        </span>
                      ) : col.field === "consultationsleft" ? ( //consultationsleft in user page
                        <span
                          style={{
                            backgroundColor: row[col.field] === "Yes" ? "#E1FCEF" : "#FFEDEF",
                            color: row[col.field] === "Yes" ? "#14804A" : "#D1293D",
                            padding: "5px 15px",
                            borderRadius: "5px",
                            textAlign: "center",
                          }}
                        >
                          {row[col.field]}
                        </span>
                      ) : col.field === "customer" ? ( //customer
                        <div className="customer-container">
                          <Image className="customer-image" src={row.customerImage} alt={row[col.field]} width={40} height={40} />
                          <span>{row[col.field]}</span>
                        </div>
                      ) : col.field === "customer consultation" ? ( //customer consultation
                        <div className="customer-container">
                          <Image className="customer-image" src={row.customerImage} alt={row[col.field]} width={40} height={40} />
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => handleRowClick(row[col.field])}
                          >
                            {row[col.field]}
                          </span>
                        </div>
                      ) : col.field === "Bannerimage" ? ( //banner page image setup in table row data
                        <div className="table-image-container">
                          <Image
                            src={
                              Array.isArray(row[col.field])
                                ? row[col.field][0]
                                : row[col.field]
                            }
                            alt={row.name || "Design Image"}
                            width={40} height={40}
                          />
                        </div>
                      ) : col.field === "dob" ? ( //banner page image setup in table row data
                        <span
                        >
                          {row[col.field]}
                        </span>
                      ) : col.field === "Deadline" ? ( //banner page image setup in table row data
                        <span
                        // onClick={() => handleDeadlinetimeClick(row)} style={{ cursor: "pointer" }}
                        >
                          {row[col.field] ? `${new Date(row[col.field]).toLocaleDateString()}` : "set Deadline"}
                        </span>
                      ) : col.field === "order_id" ? (
                        row[col.field] ?
                          <span onClick={() => handleOrderClick(row)} style={{ cursor: "pointer", color: '#e37b00', fontWeight: 600 }}>
                            {row[col.field]}
                          </span>
                          :
                          <span>
                            ----
                          </span>
                      ) : col.field === "order_ids" ? (
                        row[col.field] ?
                          <span>
                            {`${row[col.field].slice(0, 8)}...`}
                          </span>
                          :
                          <span>
                            ----
                          </span>
                      ) : col.field === "status" ?
                        (
                          <React.Fragment>
                            <Switch
                              checked={row.status} // Convert status to boolean
                              onChange={() => handleStatusClick(row)} // Trigger the status dialog
                              sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                  color: '#14804a', // Active (green) thumb
                                },
                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                  backgroundColor: '#14804a', // Active (green) track
                                },
                                '& .MuiSwitch-switchBase': {
                                  color: '#d1293d', // Active (green) thumb
                                },
                                '& .MuiSwitch-switchBase + .MuiSwitch-track': {
                                  backgroundColor: '#d1293d', // Inactive (red) track
                                },
                              }}
                            />
                            {/* <label class="switch">
                              <input type="checkbox"
                                checked={row.status} // Convert status to boolean
                                onChange={() => handleStatusClick(row)} // Trigger the status dialog
                              />
                              <span class="slider round"></span>
                            </label> */}
                          </React.Fragment>
                        ) : col.field === "Employeestatus" ?
                          (
                            <span
                              style={{
                                backgroundColor: row[col.field] === "Active" ? "#E1FCEF" : "#FFEDEF",
                                color: row[col.field] === "Active" ? "#14804A" : "#D1293D",
                                padding: "5px 15px",
                                borderRadius: "5px",
                                textAlign: "center",
                                cursor: "pointer"
                              }}
                              onClick={() => handleEmpolyeestatusClick(row)}
                            >
                              {row[col.field]}
                            </span>
                          ) : col.field === "Assignperson" ?
                            (
                              <span
                                style={{
                                  backgroundColor:
                                    row[col.field] === "Unassigned" ? "#FCEBEA" :
                                      row[col.field] === "Assigned" ? "#F1FDFF" :
                                        "", // Default Gray for unknown status
                                  color:
                                    row[col.field] === "Unassigned" ? "#FF928A " :
                                      row[col.field] === "Assigned" ? "#3CC3DF" :
                                        "#71839B", // Default Gray for unknown status
                                  padding: "5px 10px",
                                  borderRadius: "5px",
                                  textAlign: "center",
                                }}
                              >
                                {row[col.field]}
                              </span>
                            ) : col.field === "subAssignperson" ?
                              (
                                <span
                                  style={{
                                    backgroundColor:
                                      row[col.field] === "Unassigned" ? "#FCEBEA" :
                                        row[col.field] === "Assigned" ? "#F1FDFF" :
                                          "", // Default Gray for unknown status
                                    color:
                                      row[col.field] === "Unassigned" ? "#FF928A " :
                                        row[col.field] === "Assigned" ? "#3CC3DF" :
                                          "#71839B", // Default Gray for unknown status
                                    padding: "5px 10px",
                                    borderRadius: "5px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleSuborderAssignClick(row)}
                                >
                                  {row[col.field]}
                                </span>
                              ) : col.field === "Assigntailor" ?
                                (
                                  <span
                                    style={{
                                      backgroundColor:
                                        row[col.field] === "Unassigned" ? "#FCEBEA" :
                                          row[col.field] === "Assigned" ? "#F1FDFF" :
                                            "", // Default Gray for unknown status
                                      color:
                                        row[col.field] === "Unassigned" ? "#FF928A " :
                                          row[col.field] === "Assigned" ? "#3CC3DF" :
                                            "#71839B", // Default Gray for unknown status
                                      padding: "5px 10px",
                                      borderRadius: "5px",
                                      textAlign: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => handleAssigntailorClick(row)}
                                  >
                                    {row[col.field]}
                                  </span>
                                ) :
                                col.field === "Orderstatus" ?
                                  (
                                    <span


                                    >
                                      {row[col.field]}
                                    </span>
                                  ) : col.field === "suborderstatus" ?
                                    (
                                      <span
                                        style={{
                                          backgroundColor: (() => {
                                            switch (row[col.field]) {
                                              case "Unassigned":
                                                return "#FCEBEA";
                                              case "Assigned":
                                                return "#F1FDFF";
                                              case "Delivered":
                                                return "#E1FCEF";
                                              case "In Payment":
                                                return "#EBF0FA"
                                              case "In Progress":
                                                return "#FCF2E6"
                                              case "In Transit":
                                                return "#EDEDFC"
                                              case "Completed":
                                                return "#E1FCEF"; // Shared Green for these statuses
                                              case "Booked":
                                                return "#E1FCEF"; // Shared Green for these statuses
                                              case "Canceled":
                                              case "Cancelled":
                                                return "#FFEDEF";
                                              case "Hold":
                                                return "#F2EEFF";
                                              default:
                                                return "#E0E0E0"; // Default Gray for unknown status
                                            }
                                          })(),
                                          color: (() => {
                                            switch (row[col.field]) {
                                              case "Unassigned":
                                                return "#FF928A"; // Dark text for Yellow
                                              case "Assigned":
                                                return "#3CC3DF";
                                              case "Delivered":
                                                return "#006400";
                                              case "In Payment":
                                                return "#2264E5";
                                              case "In Progress":
                                                return "#AA5B00";
                                              case "In Transit":
                                                return "#5E5ADB"; // White text for other statuses
                                              case "Completed":
                                                return "#14804A"; // White text for other statuses
                                              case "Booked":
                                                return "#14804A"; // White text for other statuses
                                              case "Canceled":
                                              case "Cancelled":
                                                return "#D1293D"; // White text for other statuses
                                              case "Hold":
                                                return "#4C22E5";
                                              default:
                                                return "#fff"; // Light gray text for default
                                            }
                                          })(),
                                          padding: "5px 10px",
                                          borderRadius: "5px",
                                          textAlign: "center",
                                          // cursor: "pointer",
                                        }}
                                      // onClick={() => handleSuborderstatus(row)}
                                      >
                                        {row[col.field]}
                                      </span>
                                    ) : col.field === "paymentstatus" ?
                                      (
                                        <span
                                          style={{
                                            backgroundColor: (() => {
                                              switch (row[col.field]) {
                                                case "Unassigned":
                                                  return "#FCEBEA";
                                                case "Assigned":
                                                  return "#F1FDFF";
                                                case "Delivered":
                                                  return "#E1FCEF";
                                                case "In Payment":
                                                  return "#EBF0FA"
                                                case "In Progress":
                                                  return "#FCF2E6"
                                                case "In Transit":
                                                  return "#EDEDFC"
                                                case "Completed":
                                                  return "#E1FCEF"; // Shared Green for these statuses
                                                case "Canceled":
                                                case "Failed":
                                                  return "#FFEDEF";
                                                case "Booked":
                                                  return "#546E7A";
                                                case "Paid":
                                                  return "#EEFAFF";
                                                case "Pending":
                                                  return "#FFC107";
                                                case "Done":
                                                  return "#E1FCEF";
                                                case "Rejected":
                                                  return "#FF5722";
                                                case "Hold":
                                                  return "#F2EEFF";
                                                case "Accuried":
                                                  return "#E1FCEF";
                                                default:
                                                  return "#E0E0E0"; // Default Gray for unknown status
                                              }
                                            })(),
                                            color: (() => {
                                              switch (row[col.field]) {
                                                case "Unassigned":
                                                  return "#FF928A"; // Dark text for Yellow
                                                case "Assigned":
                                                  return "#3CC3DF";
                                                case "Delivered":
                                                  return "#006400";
                                                case "In Payment":
                                                  return "#2264E5";
                                                case "In Progress":
                                                  return "#AA5B00";
                                                case "In Transit":
                                                  return "#5E5ADB"; // White text for other statuses
                                                case "Completed":
                                                  return "#14804A"; // White text for other statuses
                                                case "Canceled":
                                                case "Failed":
                                                  return "#D1293D"; // White text for other statuses
                                                case "Booked":
                                                  return "#fff";
                                                case "Paid":
                                                  return "#22B1E5";
                                                case "Pending":
                                                  return "#fff";
                                                case "Done":
                                                  return "#14804A";
                                                case "Rejected":
                                                  return "#fff";
                                                case "Hold":
                                                  return "#4C22E5";
                                                case "Accuried":
                                                  return "#14804A";
                                                default:
                                                  return "#fff"; // Light gray text for default
                                              }
                                            })(),
                                            padding: "5px 10px",
                                            borderRadius: "5px",
                                            textAlign: "center"
                                          }}
                                        >
                                          {row[col.field]}
                                        </span>
                                      ) : col.field === "consultationtype" ?
                                        (
                                          <span
                                            style={{
                                              backgroundColor: (() => {
                                                switch (row[col.field]) {
                                                  case "In Person":
                                                    return "#F7F0FF"; // Orange for In-Person consultation
                                                  case "Online":
                                                    return "#EDF3FF"; // Blue for Online consultation
                                                  default:
                                                    return "#E0E0E0"; // Default Gray for unknown status
                                                }
                                              })(),
                                              color: (() => {
                                                switch (row[col.field]) {
                                                  case "In Person":
                                                    return "#985ADB"; // White text for contrast with orange
                                                  case "Online":
                                                    return "#004FEA"; // White text for contrast with blue
                                                  default:
                                                    return "#757575"; // Light gray text for default
                                                }
                                              })(),
                                              padding: "5px 10px",
                                              borderRadius: "5px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {row[col.field]}
                                          </span>
                                        ) : col.field === "Assignedperson" ? (
                                          <span
                                            style={{
                                              backgroundColor:
                                                row[col.field] === "Unassigned" ? "#FCEBEA" :
                                                  row[col.field] === "Assigned" ? "#F1FDFF" :
                                                    "", // Default Gray for unknown status
                                              color:
                                                row[col.field] === "Unassigned" ? "#FF928A " :
                                                  row[col.field] === "Assigned" ? "#3CC3DF" :
                                                    "", // Default Gray for unknown status
                                              padding: "5px 10px",
                                              borderRadius: "5px",
                                              textAlign: "center",
                                              // cursor: "pointer",
                                            }}
                                          >
                                            {row[col.field]}
                                          </span>
                                        ) : col.field === "fabricstatus" ? (
                                          <span
                                            style={{
                                              backgroundColor: (() => {
                                                switch (row[col.field]) {
                                                  case "Pending":
                                                    return "#FFC107"; // Yellow for Pending
                                                  case "Accuried":
                                                    return "#E1FCEF";
                                                  default:
                                                    return "#E0E0E0"; // Default Gray for unknown status
                                                }
                                              })(),
                                              color: (() => {
                                                switch (row[col.field]) {
                                                  case "Pending":
                                                    return "#FFF"; // Dark text for Yellow
                                                  case "Accuried":
                                                    return "#14804A";
                                                  default:
                                                    return "#757575"; // Light gray text for default
                                                }
                                              })(),
                                              padding: "5px 10px",
                                              borderRadius: "5px",
                                              textAlign: "center",
                                              // cursor: "pointer",
                                            }}
                                          // onClick={() => handleFabricstatus(row)}
                                          >
                                            {row[col.field]}
                                          </span>
                                        ) : col.field === "fabricstatus2" ? (
                                          <span
                                            style={{
                                              backgroundColor: (() => {
                                                switch (row[col.field]) {
                                                  case "Pending":
                                                    return "#FFC107"; // Yellow for Pending
                                                  case "Accuried":
                                                    return "#E1FCEF";
                                                  default:
                                                    return "#E0E0E0"; // Default Gray for unknown status
                                                }
                                              })(),
                                              color: (() => {
                                                switch (row[col.field]) {
                                                  case "Pending":
                                                    return "#FFF"; // Dark text for Yellow
                                                  case "Accuried":
                                                    return "#14804A";
                                                  default:
                                                    return "#757575"; // Light gray text for default
                                                }
                                              })(),
                                              padding: "5px 10px",
                                              borderRadius: "5px",
                                              textAlign: "center",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {row[col.field]}
                                          </span>
                                        ) :
                                          col.field === "suborder" ?
                                            (
                                              <>
                                                <span
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => handleAdddocumnentClick(row)}
                                                >
                                                  {row[col.field]}
                                                </span>
                                              </>
                                            ) :
                                            col.field === "preview" ?
                                              (
                                                <>
                                                  <span
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleAddImageClick(row)}
                                                  >
                                                    {row[col.field]}
                                                  </span>
                                                </>
                                              )
                                              :
                                              col.field === "suborderadd" ?
                                                (
                                                  <>
                                                    <span
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => handleSubAdddocumnentClick(row)}
                                                    >
                                                      {row[col.field]}
                                                    </span>
                                                  </>
                                                )
                                                : col.field === "location" ?
                                                  (
                                                    <>
                                                      <span>
                                                        {row[col.field]?.length <= 10 ? row[col?.field]?.substring(0, 10) : `${row[col?.field]?.substring(0, 10)}....`}
                                                      </span>
                                                    </>
                                                  ) : col.field === "price" ?
                                                    (
                                                      <>
                                                        <span>
                                                          {row[col.field] ? `₹${row[col.field]}` : "----"}
                                                        </span>
                                                      </>
                                                    )
                                                    : (
                                                      row[col.field] ? row[col.field] : "----"
                                                    )}
                    </TableCell>
                  ))}
                </TableRow>
              ))) : (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {
        currentPage &&
        <div className="pagination_table">
          <div>
            Page {currentPage}: Showing {
              (currentPage - 1) * rowsperpage + 1
            } to {
              Math.min(currentPage * rowsperpage, totalCount)
            } of {totalCount} results
          </div>

          <Pagination
            count={totalpages}
            page={currentPage}
            onChange={(e, page) => setCurrentPages(page)}
          />
        </div>
      }


    </div >
  );
};

export default CommonTable;



